
<!-- zone de contenu -->
<!-- <wiz-h-divider width="100%" height="100%" gap="0" [visible]="showMe"> -->
    <!-- <menu-panel #menuPanel height="100%" width="50px" maxWidth="200px" style="padding-left: 5px; padding-top: 0px;"></menu-panel> -->
    <wiz-group width="100%" height="100%"><router-outlet></router-outlet></wiz-group>
<!-- </wiz-h-divider> -->


